import { useState } from "react";
import { removeFromWatchlist } from "../../services/watchlist.service";
import { useAuthFetch } from "../../services/clerk.service";

const WatchlistItem = ({ item, onRemoved }) => {
  const [removing, setRemoving] = useState(false);
  const authFetch = useAuthFetch();

  const handleRemove = async () => {
    setRemoving(true);
    try {
      await removeFromWatchlist(authFetch, item.ticker, item.alert_type);
      onRemoved(item);
    } catch (err) {
      console.error("Failed to remove watchlist item:", err);
      setRemoving(false);
    }
  };

  const isUpside = item.alert_type === "UPSIDE";
  const lastNotified = item.last_notified
    ? new Date(item.last_notified).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      })
    : null;

  return (
    <div className="wi-row">
      <div className="wi-ticker">{item.ticker}</div>

      <div className="wi-meta">
        {isUpside ? (
          <span className="wi-badge wi-badge-upside">
            Upside &lt; {item.threshold_pct}%
          </span>
        ) : (
          <span className="wi-badge wi-badge-conviction">Conviction</span>
        )}
        {lastNotified && (
          <span className="wi-last-notified">Last alerted {lastNotified}</span>
        )}
      </div>

      <button
        className="wi-remove-btn"
        onClick={handleRemove}
        disabled={removing}
        title="Remove from watchlist"
      >
        {removing ? "…" : "x"}
      </button>
    </div>
  );
};

export default WatchlistItem;
